class classOption {
    constructor(id, name, checked) {
        this.id = id;
        this.name = name;
        this.checked = checked;
    }
};
export default classOption;